import personGraphic from '../../assets/icon-line-people.png';
import React, { Component } from 'react';
import styled from 'styled-components';

const PersonContainer = styled.div`
  margin-top: 11px;
  height: 19px;
  font-family: "GraphikSemiBold";
  font-size: 31px;
  font-weight: 600;
  letter-spacing: 1.92px;
  color: #808080;
`

const Image = styled.img`
  height: 19px;
      &:first-child {
        margin-left: 6px;
    }
`

export default class ShopQueueDMK extends Component {
    render() {
      const queueLength = this.props.queueLength || 0;
      const people = new Array(Math.min(queueLength, 16));
      people.fill(<Image src={personGraphic}/>);
      return(
        queueLength ?
          <PersonContainer>{queueLength}{people}</PersonContainer> :
          <PersonContainer>NO LINE</PersonContainer>
      )
    }
}



// WEBPACK FOOTER //
// ./src/components/food_court_shop_list_panel/queue_dmk.jsx